import React, { useState } from "react";
import { dateFunction } from "../../utils/dateFunction";

const InvoiceSection = ({
  transaction,
  loading,
}: {
  transaction: any;
  loading: any;
}) => {
  const [selectedYear, setSelectedYear] = useState<string>("");

  // Get unique years from transactions
  const years: string[] = transaction
    ? Array.from(
        new Set(
          transaction.map((t: any) =>
            new Date(t.transactionDate).getFullYear().toString()
          )
        )
      )
    : [];

  // Filter transactions by selected year only if a year is selected
  const filteredTransactions = selectedYear
    ? transaction?.filter(
        (t: any) =>
          new Date(t.transactionDate).getFullYear().toString() === selectedYear
      )
    : transaction;

  return (
    <div className="bg-gray-50 min-h-screen">
      {/* Tabs Navigation */}

      {/* Invoices Section */}
      <div className="mt-6 bg-white p-6 rounded-lg shadow">
        <h2 className="text-xl font-semibold mb-4">Invoices</h2>

        {/* Year Selector */}
        <div className="mb-4">
          <label htmlFor="year" className="text-gray-600 mr-2">
            Filter by year
          </label>
          <select
            id="year"
            value={selectedYear}
            onChange={(e) => setSelectedYear(e.target.value)}
            className="p-2 border rounded-md focus:ring-2 focus:ring-blue-500"
          >
            <option value="">All Years</option>
            {years.map((year: string) => (
              <option key={year} value={year}>
                {year}
              </option>
            ))}
          </select>
        </div>

        {/* Invoices Table */}
        <div className="overflow-x-auto">
          <table className="min-w-full border-collapse whitespace-nowrap">
            <thead className="bg-gray-100 text-gray-600 text-sm uppercase">
              <tr>
                <th className="p-3 text-left">Date</th>
                <th className="p-3 text-left">Invoice</th>
                <th className="p-3 text-left">Amount</th>
              </tr>
            </thead>
            <tbody className="text-gray-700">
              {filteredTransactions?.map((invoice: any, index: any) => (
                <tr
                  key={index}
                  className={`${
                    index % 2 === 0 ? "bg-gray-50" : "bg-white"
                  } hover:bg-gray-100`}
                >
                  <td className="p-3">
                    {dateFunction(invoice.transactionDate)}
                  </td>
                  <td className="p-3">{invoice.reference}</td>
                  <td className="p-3">
                    {invoice.amount
                      .toFixed(2)
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default InvoiceSection;
